var map = {
	"./images/foto-perfil.jpeg": 18,
	"./images/home/imagem-destaque.png": 13,
	"./images/icon-top.png": 19,
	"./images/icons/icon-audio-descricao.png": 20,
	"./images/icons/icon-banheiro-acessivel.png": 21,
	"./images/icons/icon-braile.png": 22,
	"./images/icons/icon-caoguia.png": 23,
	"./images/icons/icon-elevador.png": 24,
	"./images/icons/icon-estacionamento.png": 25,
	"./images/icons/icon-libras.png": 26,
	"./images/icons/icon-piso-tatil.png": 27,
	"./images/icons/icon-porta-larga.png": 28,
	"./images/icons/icon-rampa.png": 29,
	"./images/logo/logo-acessabr.svg": 30,
	"./images/logo/logo-ebac.svg": 31,
	"./images/places/mercado-municipal-de-curitiba.jpg": 57,
	"./images/places/museu-automovel.jpeg": 58,
	"./images/places/museu-oscar-niemeyer.jpg": 59,
	"./images/places/parque-sao-lourenço.jpeg": 60,
	"./images/places/torre-panoramica.webp": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;